/* eslint-disable no-unused-vars */

// import and set up swiper, used for front page carousel
// Import only the parts of swiper we need.

// import Swiper bundle with all modules installed

// eslint-disable-next-line import/no-unresolved
import Swiper, { Navigation, Controller, A11y, Keyboard } from 'swiper';

// Install modules
Swiper.use([Controller, Navigation, A11y, Keyboard]);

// const swipers = document.querySelectorAll('.swiper-container');

// for (let i = 0; i < swipers.length; i += 1) {
// 	const renderSwiper = new Swiper(swipers[i], {
// 		slidesPerView: 1,
// 		centeredSlides: true,
// 		loop: false,
// 		spaceBetween: 30,
// 		grabCursor: true,
// 		navigation: {
// 			nextEl: '.swiper-next',
// 			prevEl: '.swiper-prev',
// 		},
// 		a11y: {
// 			enabled: true,
// 		},
// 		keyboard: {
// 			enabled: true,
// 			onlyInViewport: true,
// 		},
// 	});
// }

// testimonial swipers
const swiperImages = document.querySelector(
	'.testimonial-section__image-carousel'
);
const swiperText = document.querySelector(
	'.testimonial-section__quote-carousel'
);

if (swiperImages && swiperText) {
	// Image slider instance.
	const imageSlider = new Swiper(swiperImages, {
		slidesPerView: 1,
		spaceBetween: 0,
		allowTouchMove: false,
		centeredSlides: true,
		// touchRatio: 0,
		breakpoints: {
			900: {
				slidesPerView: 1,
			},
			0: {
				slidesPerView: 1,
			},
		},
	});

	// Text swiper instance.
	// Serves as controller for image slider.
	const textSlider = new Swiper(swiperText, {
		slidesPerView: 1,
		spaceBetween: 80,
		allowTouchMove: false,
		controller: {
			by: 'slide',
			control: imageSlider,
		},
		navigation: {
			nextEl: '.quote-swiper-next',
			prevEl: '.quote-swiper-prev',
		},
		a11y: {
			enabled: true,
		},
		keyboard: {
			enabled: true,
			onlyInViewport: true,
		},
		breakpoints: {
			// no touching! on bp-charlie
			768: {
				allowTouchMove: false,
			},
			0: {
				allowTouchMove: true,
			},
		},
	});

	// tie both together after both are declared.
	imageSlider.controller.control = [textSlider];

	const imgButtons = document.querySelectorAll(
		'.testimonial-section__image-carousel__button'
	);
	// listen for click on image slider buttons and go to text slide of matching index
	imgButtons.forEach((btn, i) => {
		// console.log(i);
		btn.addEventListener('click', () => {
			textSlider.slideTo(i);
		});
	});
}

// end testimonial swipers

// stats swiper
const swiperStats = document.querySelector('.stats-section__carousel');

if (swiperStats) {
	const statsSlider = new Swiper(swiperStats, {
		slidesPerView: 1,
		centeredSlides: true,
		loop: false,
		spaceBetween: 30,
		grabCursor: true,
		navigation: {
			nextEl: '.stat-swiper-next',
			prevEl: '.stat-swiper-prev',
		},
		a11y: {
			enabled: true,
		},
		keyboard: {
			enabled: true,
			onlyInViewport: true,
		},
	});
}
